import { AgentService } from './../services/agent.service';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { BaseComponent } from 'src/app/system-common/base/base.component';
import { Component, OnInit, OnChanges, SimpleChanges, Input } from '@angular/core';
import imageCompression from 'browser-image-compression';

@Component({
  selector: 'sym-agent-document-image',
  templateUrl: './agent-document-image.component.html',
  styleUrls: ['./agent-document-image.component.scss'],
})
export class AgentDocumentImageComponent extends BaseComponent<AgentService> implements OnChanges {
  @Input() imageModelList: any;
  @Input() document: any;
  @Input() isDeleteBtnReq: any;
  @Input() isFileTypeMsgReq: any;
  public isDisable: boolean;
  uiImageModelList = [];
  max_FileSize: number;
  allowed_FileTypes: string[];
  imageExtension: string[];
  currViewImageModel: any;
  isClearFileName: boolean;
  public successResponse: any;
  public showDropImage: any;

  constructor(agentService: AgentService, public settingService: SettingService) {
    super(agentService);

    this.allowed_FileTypes = this.service.getApplicationPropertyValue('DOCUMENT_EXTENSIONS').split(',');
    this.imageExtension = this.service.getApplicationPropertyValue('IMAGE_EXTENSIONS').split(',');
    this.max_FileSize = parseInt(this.service.getApplicationPropertyValue('IMAGE_SIZE_LIMIT'));
    this.isClearFileName = false;
  }

  ngOnInit() {
    this.loadUIImageModelList();
    if (
      this.service.responseIO.data.Entity.applicationStatusCd == 'SUBMITTED' ||
      this.service.responseIO.data.Entity.applicationStatusCd == 'COMPLETED' ||
      this.service.responseIO.data.Entity.applicationStatusCd == 'ONHOLD' ||
      this.service.responseIO.data.Entity.applicationStatusCd == 'REJECTED'
    ) {
      this.isDisable = true;
    } else {
      this.isDisable = false;
    }
  }

  private loadUIImageModelList() {
    this.uiImageModelList = [];
    if (this.imageModelList != null && this.imageModelList.length > 0) {
      for (let i = 0; i < this.imageModelList.length; i++) {
        let fileDataType = this.getFileDataType(this.imageModelList[i].fileLocation);
        this.uiImageModelList.push(this.imageModelList[i]);
      }

      if (this.document.receivedStatusCd == 'RECEIVED') this.showDropImage = true;
      else this.showDropImage = false;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    super.ngOnChanges(changes);
    if (changes['imageModelList'] && changes['imageModelList'].currentValue) {
      this.loadUIImageModelList();
    }
  }

  onFileChange(event) {
    const imageToCompressed = event;
    let fileName;
    if (event.target.files && event.target.files[0]) {
      let filesAmount = event.target.files.length;
      for (let i = 0; i < filesAmount; i++) {
        fileName = event.target.files[i].name;
        let ext = fileName.substring(fileName.lastIndexOf('.') + 1, fileName.length);
        if (this.allowed_FileTypes != null && !this.allowed_FileTypes.includes(ext)) {
          this.warn(this.service.getMultilingualMessage('fileTypeAllowed', [this.allowed_FileTypes.toString()]));
          return false;
        }

        if (this.max_FileSize != null && Math.round(event.target.files[i].size / 1024) > this.max_FileSize) {
          this.warn(this.service.getMultilingualMessage('maxFileSize', [this.max_FileSize.toString()]));
          return false;
        }

        if (!this.isImageExtension(fileName)) {
          let reader = new FileReader();
          reader.onload = (event: any) => {
            //console.log(event.target.result);
            this.addImage(event.target.result, fileName);
          };
          reader.readAsDataURL(event.target.files[i]);
        } else {
          //this.imageCompression(event, fileName);
          this.compressAndAddImage(event, fileName);
        }
      }
    }
  }

  async compressAndAddImage(event, fileName: string) {
    let compressedFile = await this.service.compressImage(event);
    let reader = new FileReader();
    reader.readAsDataURL(compressedFile);

    reader.onload = (event: any) => {
      let fileContent = reader.result;
      this.addImage(fileContent, fileName);
    };
  }

  // async imageCompression(event, fileName: string) {

  //   const imageFile = event.target.files[0];
  //   // console.log('originalFile instanceof Blob', imageFile instanceof Blob); // true
  //   console.log(`Original Image Size ${imageFile.size / 1024 / 1024} MB`);

  //   const options = {
  //     maxSizeMB: 1, //maxSizeMB should not be less than 1.
  //     maxWidthOrHeight: 600, //maxWidthOrHeight helps to reduce file size and dimension.
  //     useWebWorker: true,
  //     alwaysKeepResolution: false
  //   }
  //   try {
  //     const compressedFile = await imageCompression(imageFile, options);
  //     // console.log('compressedFile instanceof Blob', compressedFile instanceof Blob); // true
  //     console.log(`Compressed File Size ${compressedFile.size / 1024 / 1024} MB`); // smaller than maxSizeMB

  //     let reader = new FileReader();
  //     reader.readAsDataURL(compressedFile);

  //     reader.onload = (event: any) => {
  //       let fileContent = reader.result;
  //       this.addImage(fileContent, fileName);
  //     };
  //   } catch (error) {
  //     console.log(error);
  //   }
  // }

  onBrowseClick(event) {
    $('#serviceDocUploadFiles_' + this.document.guid).trigger('click');
  }

  onCameraClick(event) {
    alert('Work in Progress');
  }

  addImage(event, fileName: string) {
    let respData: any;
    let imageContent = event;
    let fileDataType = this.getFileDataType(fileName);
    imageContent = imageContent.replace('data:' + fileDataType + ';base64,', '');
    let byPassOCR: boolean = false;
    this.service.addImage(imageContent, this.document, fileName).subscribe(
      (successResponse) => {
        if (successResponse['success'] == false) {
          let ans = confirm(
            this.settingService.getLabelValue('ocrFailMessage') +
              successResponse['message'] +
              this.settingService.getLabelValue('uploadFileConfirmation')
          );
          if (ans) {
            this.document.disableOcrFl = 'YES';
            byPassOCR = true;
          } else {
            this.isClearFileName = true;
          }
        }
        if (successResponse['success'] == true || byPassOCR) {
          respData = JSON.parse(JSON.stringify(successResponse));
          // respData.data.DocumentImage.fileContents = imageContent;
          respData.data.DocumentImage.fileLocation = fileName;
          if (respData.data.DocumentImage.status && respData.data.DocumentImage.status === 'N') {
            respData.data.DocumentImage.status = 'I';
          }
          this.imageModelList.push(respData.data.DocumentImage);
          this.uiImageModelList.push(respData.data.DocumentImage);
          this.showDropImage = true;
          console.log('Image added  successful.');
        }
      },
      (error) => {
        console.log('Image added failed.');
        console.log('Error:', error);
      }
    );
  }

  // onClickImage(event, imageModel: any) {
  //   this.currViewImageModel = imageModel;
  // }

  downloadImage(document): void {
    var apiUrl = '/api/documentManagement/getDocument';
    var body = {
      GUID: document.guid,
      docCategoryCd: document.docCategoryCd,
      docCategoryTypeCd: document.docCategoryTypeCd,
      documentCd: document.documentCd,
    };
    this.service.httpPost(apiUrl, body).subscribe(
      (requestBody) => {
        this.successResponse = requestBody;
        console.log('successResponse requestBody :', requestBody);
        console.log('successResponse  :', this.uiImageModelList[0].fileLocation);
        let docName =
          this.successResponse.data.DOCUMENTS.documentName != undefined
            ? this.successResponse.data.DOCUMENTS.documentName
            : this.uiImageModelList[0].fileLocation;
        this.viewImage(
          this.successResponse.data.DOCUMENTS.documentContent,
          docName,
          this.getFileDataType(docName)
        );
      },
      (error) => {
        this.error(error.error);
        console.log('Error:', error);
      }
    );
  }

  onDeleteImageClick(index, imageModel, document) {
    var apiUrl = '/api/documentManagement/deleteDocument';
    var body = {
      GUID: document.guid,
    };

    this.service.httpPost(apiUrl, body).subscribe(
      (requestBody) => {
        this.successResponse = requestBody;
        console.log('successResponse requestBody :', requestBody);
        //console.log('successResponse  :', this.uiImageModelList[0].fileLocation);

        document.acceptancsStatusCd = 'PENDING';
        document.receivedStatusCd = 'PENDING';
        this.service.setUpdated(document);
      },
      (error) => {
        this.error(error.error);
        console.log('Error:', error);
      }
    );
    this.uiImageModelList.splice(index, 1);
    this.service.setDeleted(imageModel);
    this.showDropImage = false;
  }

  isImageExtension(fileName: string): boolean {
    let ext = fileName.substring(fileName.lastIndexOf('.') + 1, fileName.length);
    // let validExtensions:string[]=["jpg","bmp","gif","png"];
    return this.imageExtension.includes(ext);
  }

  viewFile(fileContents: string, fileName: string) {
    this.downloadOrOpenContent(fileContents, undefined, fileName, true, { width: 400, height: 400 });
  }

  viewImage(fileData: string, fileName: string, fileType: string) {
    const byteCharacters = atob(fileData);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: fileType });

    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName || 'downloaded-file';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  onInputFileClick(event) {
    if (this.isClearFileName) {
      event.target.value = '';
      this.isClearFileName = false;
    }
  }
}
